import React, {useState, useEffect, useMemo} from 'react';
import styled from 'styled-components';
import Utility from '../../../../util/utilityfunctions';
import EllipseControl from '../../EllipsesControl/EllipsesControl';
import CompareSnapshotLabel from '../../../Common/CanvasForm/CompareSnapshotLabel';
import Icon from '../../../Common/BaseComponentWrappers/MotifIcon';
import {MotifImageIcFilterNone24px, IconoirTools} from '@ey-xd/motif-icon';
import {labels} from '../../../../util/utils';

export default function SectionItem({
	section,
	targetHeader,
	headerId,
	source,
	onShowDrawerChanges,
	selectedDocumentsCount
}) {
	const [targetSection, setTargetSection] = useState(null);
	const isDisabled = source === 'CompareResponses' && ((selectedDocumentsCount && selectedDocumentsCount === 0) || section?.isCustom || section?.isDuplicate);

	useEffect(() => {
		if (targetHeader?.sections?.length > 0) {
			setTargetSection(targetHeader?.sections?.find((c) => c.id === section?.id));
		}
	}, [section?.id, targetHeader]);

	const sectionName = useMemo(() => {
		return (
			(section?.formSectionName ?? section?.name) +
			`${(section?.isDuplicate || section?.isCustom) && section?.customLabel ? ` - ${section?.customLabel}` : ''}`
		);
	}, [section]);

	return (
		<StyledSection className={`StyledSection ${isDisabled && 'disabledSection'}`}>
			<section className="section-content">
				<EllipseControl
					content={Utility.getHtmlTextElement(sectionName)}
					id={section?.id}
					tooltip={Utility.getHtmlTextElement(sectionName)}
					displayId={''}
					noOfLines={1}
					onClick={() => {
						if (!isDisabled) {
							onShowDrawerChanges({
								sectionId: targetSection ? targetSection?.id : section?.id,
								headerId: targetHeader ? targetHeader?.id : headerId,
								sectionName
							});
						}
					}}
				/>
				{section?.isDuplicate && (
					<Icon className="duplicate-icon" src={MotifImageIcFilterNone24px} title={labels.duplicate} />
				)}
				{section?.isCustom && (
					<section className="ares-custom-icon">
						<Icon src={IconoirTools} title={labels.custom} />
					</section>
				)}
			</section>
			<section className="right-section-content">
				{targetSection && <CompareSnapshotLabel snapshotObject={targetSection} isTrackChanges={source} />}
			</section>
		</StyledSection>
	);
}

const StyledSection = styled.h2`
	margin: 0;
	padding: var(--px-24) var(--px-24) 0 var(--px-24);
	display: flex;
	&.disabledSection {
		opacity: 0.5;
		pointer-events: none;
	}
	.section-content {
		display: flex;
		align-items: center;
		width:65%;
		.ellipses {
			width:auto;
			div {
				font-size: var(--px-16);
				color: var(--blue-600);
				font-weight: 400;
				line-height: var(--px-24);
				cursor: pointer;
			}
		}
		.ellipses:hover {
			div {
				text-decoration: underline;
				cursor: pointer;
			}
		}
		.duplicate-icon {
			display: flex;
			margin-left: var(--px-12);
		}
		.ares-custom-icon {
			display: flex;
			justify-content: center;
			margin-left: var(--px-8);
			.motif-icon {
				display: flex;
				justify-content: center;
				align-items: center;
				color: var(--neutrals-700);
				width: var(--px-20);
				svg {
					width: var(--px-20);
					height: var(--px-20);
				}
			}
		}
	}
	.right-section-content {
		display: flex;
		margin-left: auto;
		.ares-custom-icon {
			margin-right: var(--px-6);
			display: flex;
			justify-content: center;
			.motif-icon {
				display: flex;
				justify-content: center;
				align-items: center;
				color: var(--neutrals-700);
				svg {
					width: var(--px-20);
					height: var(--px-20);
				}
			}
		}
	}
`;
